import titleBox from "@/components/title/title.vue";
export default {
  components: {
    titleBox
  }
};